import { motion, AnimatePresence } from 'framer-motion';
import { X, ExternalLink, Crown } from 'lucide-react';
import { PixDiscordPaymentNotice } from '@/components/payment/PixDiscordPaymentNotice';

interface PaymentModalProps {
    show: boolean;
    onClose: () => void;
    paymentData: any;
    paymentError: string;
    onProceed: () => void;
}

export function PaymentModal({
    show,
    onClose,
    paymentData,
    paymentError,
    onProceed,
}: PaymentModalProps) {
    return (
        <AnimatePresence>
            {show && (
                <>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        className="fixed inset-0 z-[200] bg-black/60 backdrop-blur-sm"
                        onClick={onClose}
                    />

                    <motion.div
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
                        className="fixed inset-0 z-[201] flex items-center justify-center p-4 pointer-events-none"
                    >
                        <div
                            className="bg-neutral-950 border border-white/5 rounded-2xl w-full max-w-sm shadow-2xl pointer-events-auto"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="flex items-center justify-between px-6 py-4 border-b border-white/5">
                                <h3 className="text-lg font-bold text-white">Confirmar Assinatura</h3>
                                <button
                                    onClick={onClose}
                                    className="p-2 hover:bg-white/5 rounded-lg transition-colors text-white/40 hover:text-white"
                                >
                                    <X size={20} />
                                </button>
                            </div>

                            <div className="p-6 space-y-5">
                                <PixDiscordPaymentNotice />

                                {paymentData?.plan && (
                                    <div className="flex items-center gap-3 p-4 rounded-xl bg-yellow-500/5 border border-yellow-500/20">
                                        <Crown size={22} className="text-yellow-500 shrink-0" />
                                        <div>
                                            <p className="text-white font-semibold">{paymentData.plan.name || 'Plano VIP'}</p>
                                            {paymentData.plan.descricao && (
                                                <p className="text-white/50 text-sm mt-0.5">{paymentData.plan.descricao}</p>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <p className="text-sm text-white/60 text-center">
                                    Você será redirecionado para a plataforma de pagamento para concluir sua assinatura.
                                </p>

                                {paymentError && (
                                    <div className="p-3 bg-red-500/10 border border-red-500/20 rounded-lg text-red-400 text-sm text-center">
                                        {paymentError}
                                    </div>
                                )}

                                <div className="flex gap-3">
                                    <button
                                        onClick={onClose}
                                        className="flex-1 py-3 px-4 bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg text-white font-medium transition-colors"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        onClick={onProceed}
                                        className="flex-1 py-3 px-4 bg-orange-500 hover:bg-orange-600 rounded-lg text-white font-semibold transition-colors shadow-lg shadow-orange-500/20 flex items-center justify-center gap-2"
                                    >
                                        <ExternalLink size={16} />
                                        Ir para Pagamento
                                    </button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
}
